/**
 * Opens the built-in Contact us dialog, optionally pre-filled.
 *
 * Anywhere that wants to start a conversation with the CatTrax team (nav menu,
 * feature tips, empty states) goes through here, so the message always lands in
 * the same inbox and the user can edit it before it is sent.
 */
app.factory("ContactDialog", [
	"$modal",
	"$rootScope",
	"EmailAPI",
	function ($modal, $rootScope, EmailAPI) {
		return {
			/**
			 * @param {string} [prefilledMessage] draft body - the user can edit or clear it.
			 */
			open: function (prefilledMessage) {
				const scope = $rootScope.$new(true);

				scope.EA = EmailAPI;
				scope.message = { contact: prefilledMessage || "" };

				scope.sendContactDetails = function () {
					if (scope.sending) {
						// A second click while the first send is in flight would send the message twice.
						return;
					}
					scope.sending = true;
					scope.EA.isProcessing = true;
					scope.EA.contact(scope.message.contact)
						.then(function () {
							scope.contactModal.hide();
							scope.successContactModal = $modal({
								scope: scope,
								templateUrl: "app/src/views/templates/modal.success-contact.tpl.html",
								show: true,
								title: "MESSAGE SENT",
							});
						})
						.finally(function () {
							scope.sending = false;
							scope.EA.isProcessing = false;
						});
				};

				scope.contactModal = $modal({
					scope: scope,
					templateUrl: "app/src/views/templates/modal.contact.tpl.html",
					show: true,
					title: "CONTACT US",
				});

				return scope.contactModal;
			},
		};
	},
]);
